export interface SummarySection {
  id: string;                    // 인덱스 기반 ("0", "1", ...)
  heading: string;               // 섹션 제목
  timestamp?: string;            // "2:26" 또는 "7:07-12:30"
  timestampSeconds?: number;     // 시작 타임스탬프 초 단위
  timestampEndSeconds?: number;  // 끝 타임스탬프 초 단위 (범위 시)
  body: string;                  // 섹션 본문 마크다운
}

export function parseTimestampToSeconds(timestamp: string): number {
  const parts = timestamp.split(":");
  if (parts.length === 2) {
    const [minutes, seconds] = parts.map(Number);
    return minutes * 60 + seconds;
  } else if (parts.length === 3) {
    const [hours, minutes, seconds] = parts.map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 0;
}

export function isSectionedSummary(markdown: string): boolean {
  if (!markdown) return false;
  return /^## /m.test(markdown);
}

/** Matches a trailing timestamp like `(2:26)` or `(7:07-12:30)` in a heading */
const HEADING_TIMESTAMP_RE =
  /\s*\(([\d]+:[\d]{2}(?::[\d]{2})?)(?:-([\d]+:[\d]{2}(?::[\d]{2})?))?\)\s*$/;

export function parseSummaryLong(markdown: string): SummarySection[] {
  if (!markdown) return [];

  if (!isSectionedSummary(markdown)) {
    return [{ id: "0", heading: "", body: markdown.trim() }];
  }

  const sectionChunks = markdown.split(/^## /m).slice(1);

  return sectionChunks.map((section, index) => {
    const lines = section.split("\n");
    const headingLine = lines[0].trim();
    const body = lines.slice(1).join("\n").trim();

    const timestampMatch = headingLine.match(HEADING_TIMESTAMP_RE);

    if (!timestampMatch) {
      return { id: String(index), heading: headingLine, body };
    }

    const startTs = timestampMatch[1];
    const endTs = timestampMatch[2];
    const heading = headingLine.replace(HEADING_TIMESTAMP_RE, "").trim();
    const result: SummarySection = {
      id: String(index),
      heading,
      timestamp: endTs ? `${startTs}-${endTs}` : startTs,
      timestampSeconds: parseTimestampToSeconds(startTs),
      body,
    };
    if (endTs) {
      result.timestampEndSeconds = parseTimestampToSeconds(endTs);
    }
    return result;
  });
}
